// src/components/Events.jsx
import { useEffect, useState } from "react";
import axios from "axios";

const API_URL = "https://bcm-backend-9ca9.onrender.com"; // backend URL

export default function Events() {
  const [events, setEvents] = useState([]);

  useEffect(() => {
    axios
      .get(`${API_URL}/events`)
      .then((res) => setEvents(res.data))
      .catch((err) => console.error("Failed to fetch events:", err));
  }, []);

  return (
    <section id="events" className="bg-white py-24 px-6 md:px-10">
      <div className="max-w-6xl mx-auto">
        {/* Section Heading */}
        <h2 className="text-4xl md:text-5xl font-extrabold text-maroon text-center mb-16">
          Events
        </h2>

        {/* Grid layout */}
        {events.length > 0 ? (
          <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-3">
            {events.map((event) => {
              const formattedDate = event.date
                ? new Date(event.date).toLocaleDateString(undefined, {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  })
                : "Date not available";

              return (
                <div
                  key={event._id}
                  className="bg-cream rounded-2xl border border-gray-200 overflow-hidden shadow-sm 
                  transform transition-all duration-300 hover:-translate-y-2 hover:shadow-xl"
                >
                  {/* Event image */}
                  <div className="w-full h-52 bg-gray-100 overflow-hidden flex items-center justify-center">
                    {event.imageUrl ? (
                      <img
                        src={event.imageUrl}
                        alt={event.title || "Event"}
                        className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
                      />
                    ) : (
                      <span className="text-gray-500">No Image</span>
                    )}
                  </div>

                  {/* Event content */}
                  <div className="p-6 text-left">
                    <h3 className="text-2xl font-semibold text-maroon mb-2">
                      {event.title || "Untitled Event"}
                    </h3>
                    <span className="text-sm text-gray-600 mb-4 block">
                      {formattedDate}
                    </span>
                    <p className="text-gray-800 text-base leading-relaxed">
                      {event.description || "No description provided."}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <p className="text-center text-gray-600 text-lg">
            No events available at the moment. 🎉
          </p>
        )}
      </div>
    </section>
  );
}
